import React from "react";
import { Stepper } from "./Stepper";

function DesignApproach() {
  return (
    <section className="container pb-40 pt-40 ">
      <h6 className="sub-title main-color mb-20">Design Process/Approach</h6>
      <span className="design-approach-logo mb-20">
        <img src="/assets/imgs/stepper/audience.png" alt="Design Approach" />
      </span>
      <div className="mb-20 stepper-header">
        <h2 className="design-approach-title ">
          My Process for Creating Human-Centered Solutions
        </h2>
        <p className="mt-20 design-approach-sub-title">
          A journey through my design process, where I apply the Double Diamond
          framework to transform insights into innovative, user-first
          experiences.
        </p>
      </div>
      <Stepper />
    </section>
  );
}

export default DesignApproach;
